import React, { useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";

interface MaliciuosDialogProps {
  open: boolean;
  onClose: () => void;
  autoCloseDelay?: number; // Auto-close after this many milliseconds (default 5000ms = 5 seconds)
}

const MaliciuosDialog: React.FC<MaliciuosDialogProps> = ({ open, onClose, autoCloseDelay = 5000 }) => {
  // Auto-close after specified delay
  useEffect(() => {
    if (open) {
        const timer = setTimeout(() => {
          onClose();
        }, autoCloseDelay);
        return () => clearTimeout(timer);
    }
  }, [open, autoCloseDelay, onClose]);

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        // Prevent closing when clicking outside (backdrop) - only allow closing from X button
        if (reason === "backdropClick") {
          return;
        }
        onClose();
      }}
      PaperProps={{
        sx: {
          backgroundColor: PureLightThemeCaaS.colors.alpha.black[100],
          color: PureLightThemeCaaS.colors.alpha.white[100],
          boxShadow: "4px 4px 12px rgba(0,0,0,0.25)",
          borderRadius: "8px",
          border: `1px solid ${PureLightThemeCaaS.colors.alpha.white[30]}`,
          minWidth: "300px",
          maxWidth: "500px",
        },
      }}
      slotProps={{
        backdrop: {
          sx: {
            position: "fixed",
            backdropFilter: "blur(6px) !important",
            WebkitBackdropFilter: "blur(1px) !important",
            backgroundColor: "rgba(0, 0, 0, 0.85)",
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          color: "#d32f2f",
          fontWeight: "bold",
          fontSize: "16px",
          fontFamily: '"Inter", sans-serif',
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",

          pr: 1,
          pb: 0,
          pt: 0.5,
        }}
      >
        Content Warning
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: PureLightThemeCaaS.colors.alpha.white[100],
            "&:hover": {
              backgroundColor: PureLightThemeCaaS.colors.alpha.black[50],
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pb: 1 }}>
        <Typography
          sx={{
            color: PureLightThemeCaaS.colors.alpha.white[70],
            fontWeight: 500,
            fontSize: "14px",
            lineHeight: "1.5",
            fontFamily: '"Inter", sans-serif',
          }}
        >
          Could not save at this time. This message violates our terms and conditions.
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default MaliciuosDialog;
